/**
 *  CampaignProductTable script file
**/
import customFormatters from '@/filters/customFormatters'
import moment from 'moment'
import { CHANNEL_LABELS } from '@/utils/campaignOptions'

export default {
  name: 'CampaignChannelTable',
  mixins: [customFormatters],
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    },
    meta: {
      type: Object
    },
    sortBy: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      products: [],
      channelLabels: CHANNEL_LABELS,
      sortByField: 'name',
      sortByFiledBefore: '',
      sortDirection: 'asc'
    }
  },
  computed: {
    channelType () {
      return this.$route.params.type
    },
    sortType () {
      const desc = this.sortBy.indexOf('-') !== -1
      return desc ? 'desc' : 'asc'
    },
    sortKey () {
      return this.sortBy.replace('-', '')
    }
  },
  methods: {
    getDayDiff (campaign) {
      const start = moment(campaign.start_date, 'YYYY-MM-DD').parseZone()
      const finish = moment(campaign.finish_date, 'YYYY-MM-DD').parseZone()
      const diff = finish.diff(start, 'days') + 1
      return diff
    },
    onCampaignToggle (open, campaign) {
      if (open && !campaign.products) {
        this.fetchProductsForCampaign(campaign)
      }
    },
    expandChannels (campaignId) {
      const campaign = this.data.find(c => c.id === campaignId)
      this.$set(campaign, 'products', campaign.channels)
      this.$set(campaign, 'product_count', campaign.channels.length)
    },
    onChangePage ({ currentPage }) {
      this.$emit('pageChange', currentPage)
    },
    handleSort (key) {
      this.sortByField = key

      if (this.sortByFiledBefore === key) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      }

      this.sortByFiledBefore = key

      this.data.sort((a, b) => {
        const valueA = a[key]
        const valueB = b[key]

        if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1
        if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1

        return 0
      })
    }
  }
}
